<template>
<div :class="isCollapseForInit ?  'model-form-list-box-two':'model-form-list-box'">
    <template v-if="showCollapse">
      <SideLeftTree @changeLeftTree="changeLeftTree" v-if="!fromReport"/>
    </template>
   <div class="model-FormList">
        <!-- <div class="model-desc" v-if="defaultSearchField && defaultSearchField.length>0">
            <div class="form-btn-tools">
                <i class="el-icon-back"  v-show="isNewPage&&fromReport" @click="showList" style="cursor: pointer;color:#409eff;"></i>
                <el-button class="btn-style" :icon="leftTitleFlag?'el-icon-search':'el-icon-menu'" type="primary" v-if="showLeft" :title="leftTitleFlag?'筛选条件':'查看菜单'"  @click="changeLeftList" circle></el-button>
                <el-button class="btn-style" icon="el-icon-refresh" type="primary" title="刷新数据"  @click="_initFormData()">刷新</el-button> -->
                <!-- <el-dropdown split-button type="primary" @command="sendMessageToPeople">
                消息提醒
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="systemPeople">按系统人员</el-dropdown-item>
                    <el-dropdown-item command="formField">按表单字段</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown> -->
                <!-- 表单id写死为国融的工资表 -->
                <!-- <el-button class="btn-style" icon="el-icon-s-promotion" type="primary" title="工资单推送"  @click="sendMessageToPeople()" v-if="searchParams.formId==='53b075a80f544a6d86b1602eddcd8277'"></el-button>
                <el-button class="btn-style" v-show="isModelForm && formBtnAuth.isShowAdd" icon="el-icon-circle-plus-outline" type="primary" title="新增"  @click="switchAddFormData()" circle></el-button>
                <el-button class="btn-style" v-if="isModelForm && formBtnAuth.isShowSyn && selectedModel.modelType===1 " icon="el-icon-copy-document" type="primary" title="同步流程数据"  @click="syncProcessData()"></el-button>
                <el-button class="btn-style" v-show="isModelForm && formBtnAuth.isShowImport" icon="iconfont icon-other-xiazaidaoru" type="primary" title="导入"  @click="dataImport()" circle></el-button>
                <el-button class="btn-style" v-show="formBtnAuth.isShowExport" icon="iconfont icon-other-daochuquanbu" type="primary" v-preventReClick = "30000" title="导出全部" @click="dataExport()" circle></el-button>
                <el-button class="btn-style" v-show="formBtnAuth.isShowExport" icon="iconfont icon-other-daochu" type="primary" v-preventReClick = "30000" title="导出当前" @click="dataCurrentExport()" circle></el-button>
                <el-button class="btn-style" icon="el-icon-search" type="primary" title="筛选条件"  @click="handleFilterCondition()" v-if="fromReport" circle></el-button>
                <el-button class="btn-style" icon="iconfont icon-other-ziduankongzhi" type="primary" title="显示字段"  @click="handleFilterField()" circle></el-button>
                <el-button icon="el-icon-postcard" v-if="showCrossCount" type="primary" @click="handleUpdCrossCountFieldData" circle></el-button>
                <el-button icon="el-icon-data-line" v-if="showRPATrigger && formBtnAuth.isShowAdd" type="warning" @click="handleRPATriggerData" circle></el-button>
                <el-button class="btn-style" v-show="formBtnAuth.isShowConfig" v-permission="permission.isShowApplicationConfig" title="配置应用" icon="iconfont icon-other-moxingshezhi" type="primary" @click="handleConfigApplication" circle></el-button>
                <el-button class="btn-style" v-show="isModelForm && formBtnAuth.isShowDelete" type="danger" icon="el-icon-delete" title="批量删除" @click="handleModelFormBatchDelete()" circle></el-button>
                <el-button class="btn-style"   v-if="showMaps" type="primary" icon="iconfont icon-other-ditu" title="地图分布" @click="showMapsData()" circle></el-button>
                <el-button size="mini" v-show="selectedModel.modelType==2" title='业务树关系图' circle icon="el-icon-connection"  @click="handelShowReportRelateTree"></el-button>
                <el-tooltip v-show="isModelForm" class="item" effect="light" content="当单元格字段太长显示不全时，选择多行模式，字段数据多行显示" placement="top" circle>
                    <el-checkbox class="checkBox-style" v-model="hideOverflowTooltip" @change="handleHideOverflowTooltip"><el-tag size="mini">多行</el-tag></el-checkbox>
                </el-tooltip>
                <el-tooltip v-show="isModelForm && isCanShowSummery" style='margin-left: -1.5vw;' class="item" effect="light" content="数字、计算、统计等类型的字段在本页底部进行合计显示" placement="top">
                    <el-checkbox class="checkBox-style" v-if="isCanShowSummery" v-model="isShowSummary" @change="handleShowSummery"><el-tag size="mini">合计</el-tag></el-checkbox>
                </el-tooltip>
                <el-tooltip v-show="isModelForm" style='margin-left: -1.5vw;' class="item" effect="light" content="当选择显示业务流程相关时，表单数据会将关联的流程信息带出" placement="top">
                    <el-checkbox class="checkBox-style" v-model="isViewProcessInfo" @change="handleViewProcessInfo" :disabled="canChecked"><el-tag size="mini">业务流</el-tag></el-checkbox>
                </el-tooltip>
                <el-tooltip v-show="isModelForm && isApprovalForm" style='margin-left: -1.5vw;' class="item" effect="light" content="当选择显示审批流相关时，表单数据会将审批状态和审批详情带出" placement="top">
                    <el-checkbox class="checkBox-style" v-model="isViewApprovalInfo" @change="handleViewProcessInfo" :disabled="canChecked"><el-tag size="mini">审批流</el-tag></el-checkbox>
                </el-tooltip>
                <el-tooltip v-show="isModelForm&&isViewProcessInfo" style='margin-left: -1.5vw;' class="item" effect="light" content="当选择显示终止状态时，会过滤出业务流程属于终止状态的表单数据" placement="top">
                  <el-checkbox class="checkBox-style" v-model="isViewTerminalStatus" @change="handleViewProcessInfo" :disabled="canChecked"><el-tag size="mini">终止状态</el-tag></el-checkbox>
              </el-tooltip>
                <el-tooltip v-show="this.selectedModel.modelType === 2"   :content="isFilterDuplicateData?'去掉子表重复数据':'包含子表重复数据'" placement="top">
                  <el-switch
                      v-model="isFilterDuplicateData"
                       @change="_initFormData"
                      >
                  </el-switch>
                </el-tooltip>
                <el-tooltip v-show="fromReport" content="根据设置的规则可以按月查询数据" placement="top">
                    <el-date-picker
                        v-model="selectedMonth"
                        type="monthrange"
                        align="right"
                        unlink-panels
                        format="yyyy 年 MM 月"
                        value-format="yyyy-MM"
                        clearable
                        :editable="true"
                        range-separator="至"
                        start-placeholder="开始月份"
                        end-placeholder="结束月份"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-tooltip>
            </div>
            <div class="form-search-tools" v-if="defaultSearchField && defaultSearchField.length>0"> -->
                <!-- <div class="form-search-tools-item" v-if="!showMoreSearch">
                    <SearchFieldItem  :key="defaultSearchField[0].id" :field="defaultSearchField[0]" :formData="formData" />
                </div> -->
                <!-- <div  class="form-search-tools-btns">
                    <el-button type="primary" icon="el-icon-search" @click="searchFieldData()" class="search-btn">搜索</el-button>
                    <el-button type="primary" @click="showSearchFieldData()">More<i class="el-icon-d-arrow-right"></i></el-button>
                </div> 
            </div>
        </div> -->
        <div class="model-desc" style="height:40px;line-height:26px;justify-content: left;padding-left: 10px;">
            <div v-if="!isShowAggregateList" class="btn-box">
                <i class="el-icon-back"  v-show="isNewPage&&fromReport" @click="showList" style="cursor: pointer;color:#409eff;"></i>
                <template v-if="!isManageMode">
                    <el-button class="btn-style" :icon="leftTitleFlag?'el-icon-search':'el-icon-menu'" type="primary" v-if="showLeft" :title="leftTitleFlag?'筛选条件':'查看菜单'"  @click="changeLeftList">{{leftTitleFlag?'筛选':'菜单'}}</el-button><el-tag title="清空筛选条件" v-if="this.conditionLocalMap&&this.conditionLocalMap.size>0"  @click="handleFilterCondition" type="warning" closable :disable-transitions="false" @close="clearConditionLocalMap" >{{this.conditionLocalMap.size}}</el-tag>
                </template>
                <template v-else>
                    <el-button class="btn-style" icon="el-icon-search" type="primary" @click="handleFilterCondition">筛选</el-button> 
                </template>
                <!-- <el-button class="btn-style" icon="el-icon-search" type="primary" @click="handleFilterCondition">筛选</el-button> <el-tag title="清空筛选条件" v-if="this.conditionLocalMap&&this.conditionLocalMap.size>0" type="warning" closable :disable-transitions="false" @close="clearConditionLocalMap" >{{this.conditionLocalMap.size}}</el-tag> -->
                <el-button class="btn-style" icon="el-icon-refresh" type="primary" title="刷新数据"  @click="_initFormData()">刷新</el-button>
                <!-- <el-dropdown split-button type="primary" @command="sendMessageToPeople">
                消息提醒
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="systemPeople">按系统人员</el-dropdown-item>
                    <el-dropdown-item command="formField">按表单字段</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown> -->
                <!-- 表单id写死为国融的工资表 -->
                <el-button class="btn-style" icon="el-icon-s-promotion" type="primary" title="工资单推送"  @click="sendMessageToPeople()" v-if="searchParams.formId==='53b075a80f544a6d86b1602eddcd8277'">工资单推送</el-button>
                <el-button class="btn-style" v-show="isModelForm && formBtnAuth.isShowAdd" icon="el-icon-circle-plus-outline" type="primary" title="新增"  @click="switchAddFormData()">新增</el-button>
                <el-button class="btn-style" v-if="isModelForm && formBtnAuth.isShowSyn && selectedModel.modelType===1 " icon="el-icon-copy-document" type="primary" title="同步流程数据"  @click="syncProcessData()">同步数据</el-button>
                <el-button class="btn-style" v-show="isModelForm && formBtnAuth.isShowImport" icon="iconfont icon-other-xiazaidaoru" type="primary" title="导入"  @click="dataImport()">&nbsp;&nbsp;导入</el-button>
                
                <!-- 
                <el-button class="btn-style" v-show="formBtnAuth.isShowExport" icon="iconfont icon-other-daochuquanbu" type="primary" v-preventReClick = "30000" title="导出全部" @click="dataExport()">&nbsp;&nbsp;导出全部</el-button>
                <el-button class="btn-style" v-show="formBtnAuth.isShowExport" icon="iconfont icon-other-daochu" type="primary" v-preventReClick = "30000" title="导出当前" @click="dataCurrentExport()">&nbsp;&nbsp;导出当前</el-button>
                -->
                <el-dropdown split-button v-show="formBtnAuth.isShowExport" v-preventReClick = "30000" type="primary" icon="el-icon-upload2"  @command="exportData"  >
                  导出
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="iconfont icon-other-daochu" command="current">导出当前</el-dropdown-item>
                    <el-dropdown-item icon="iconfont icon-other-daochuquanbu" command="all">导出全部</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!--<el-button class="btn-style" v-if="isApprovalForm && isViewApprovalInfo" icon="el-icon-search" type="primary" @click="handleApprovalStatusFilter()">审批状态</el-button>-->
                <el-button class="btn-style" icon="el-icon-search" type="primary" title="筛选条件"  @click="handleFilterCondition()" v-if="fromReport">筛选</el-button>
                <el-button class="btn-style" icon="iconfont icon-other-ziduankongzhi" type="primary" title="显示字段"  @click="handleFilterField()">&nbsp;&nbsp;显示字段</el-button>
                <el-button icon="el-icon-postcard" v-if="showCrossCount" type="primary" @click="handleUpdCrossCountFieldData">跨年统计</el-button>
                <el-button icon="el-icon-data-line" v-if="showRPATrigger" type="warning" @click="handleRPATriggerData" >RPA</el-button>
                <el-button class="btn-style" v-show="formBtnAuth.isShowConfig" v-permission="permission.isShowApplicationConfig" icon="iconfont icon-other-moxingshezhi" type="success" @click="handleConfigApplication" >&nbsp;&nbsp;配置应用</el-button>
                <!-- <el-button class="btn-style" v-show="!fullScreen" icon="el-icon-rank" type="primary"  @click.stop="handleFullScreen()">全屏</el-button> -->
                <el-button class="btn-style" v-show="isModelForm && formBtnAuth.isShowDelete" type="danger" icon="el-icon-delete" title="批量删除" @click="handleModelFormBatchDelete()">删除</el-button>
                <el-button class="btn-style"   v-if="showMaps" type="primary" icon="iconfont icon-other-ditu" title="地图分布" @click="showMapsData()">数据分布</el-button>
                <el-button size="mini" v-show="selectedModel.modelType==2" title='业务树关系图' circle icon="el-icon-connection" @click="handelShowReportRelateTree"></el-button>
                <el-tooltip v-show="isModelForm" class="item" effect="light" content="当单元格字段太长显示不全时，选择多行模式，字段数据多行显示" placement="top">
                    <el-checkbox class="checkBox-style" v-model="hideOverflowTooltip" @change="handleHideOverflowTooltip"><el-tag size="mini">多行</el-tag></el-checkbox>
                </el-tooltip>
                <template v-if="isCanShowSummery">
                  <el-tooltip v-show="isModelForm" style='margin-left: -1.5vw;' class="item" effect="light" content="数字、计算、统计等类型的字段在本页底部进行合计显示" placement="top">
                      <el-checkbox class="checkBox-style" v-model="isShowSummary" @change="handleShowSummery"><el-tag size="mini">合计</el-tag></el-checkbox>
                  </el-tooltip>
                </template>
                <el-tooltip v-show="isModelForm" style='margin-left: -1.5vw;' class="item" effect="light" content="当选择显示业务流程相关时，表单数据会将关联的流程信息带出" placement="top">
                    <el-checkbox class="checkBox-style" v-model="isViewProcessInfo" @change="handleViewProcessInfo" :disabled="canChecked"><el-tag size="mini">业务流</el-tag></el-checkbox>
                </el-tooltip>
                <el-tooltip v-show="isModelForm && isApprovalForm" style='margin-left: -1.5vw;' class="item" effect="light" content="当选择显示审批流相关时，表单数据会将审批状态和审批详情带出" placement="top">
                    <el-checkbox class="checkBox-style" v-model="isViewApprovalInfo" @change="handleViewProcessInfo" :disabled="canChecked"><el-tag size="mini">审批流</el-tag></el-checkbox>
                </el-tooltip>
                <el-tooltip v-show="isModelForm&&isViewProcessInfo" style='margin-left: -1.5vw;' class="item" effect="light" content="当选择显示终止状态时，会过滤出业务流程属于终止状态的表单数据" placement="top">
                  <el-checkbox class="checkBox-style" v-model="isViewTerminalStatus" @change="handleViewProcessInfo" :disabled="canChecked"><el-tag size="mini">终止状态</el-tag></el-checkbox>
              </el-tooltip>
                <el-tooltip v-show="this.selectedModel.modelType === 2"   :content="isFilterDuplicateData?'去掉子表重复数据':'包含子表重复数据'" placement="top">
                  <el-switch
                      v-model="isFilterDuplicateData"
                       @change="_initFormData"
                      >
                  </el-switch>
                </el-tooltip>
                <el-tooltip v-show="fromReport" content="根据设置的规则可以按月查询数据" placement="top">
                    <el-date-picker
                        v-model="selectedMonth"
                        type="monthrange"
                        align="right"
                        unlink-panels
                        format="yyyy 年 MM 月"
                        value-format="yyyy-MM"
                        clearable
                        :editable="true"
                        range-separator="至"
                        start-placeholder="开始月份"
                        end-placeholder="结束月份"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-tooltip>
                <el-tooltip v-show="fromReport" content="清空缓存数据，重新加载最新数据进行查询" placement="top">
                  <el-button style='margin-left: 10px;' type="info" @click="clearCacheData" plain>刷新缓存</el-button>
                </el-tooltip>
                <el-tooltip v-show="fromReport" content="报表查询时多表关联查询模式：分为左链接left join模式和内连接inner模式，默认为左链接left join模式。  1.左链接left join模式，以左表(主表)为参照,显示左表所有数据,右表中没有则显示空白  2.内连接inner join模式，只查询出左表(主表)及其它表单间符合等值关联条件的数据;" placement="top">
                  <el-switch
                    style='margin-left: 10px;'
                    v-model="reportLeftJoinMode"
                    @change="changeJoinMode"
                    active-text="左链接"
                    inactive-text="内连接">
                  </el-switch>
                </el-tooltip>
                <el-button type="danger" @click="showSearchFieldData()" v-if="defaultSearchField && defaultSearchField.length>0">更多查询条件<i class="el-icon-d-arrow-right"></i></el-button>
                <el-button type="primary" icon="el-icon-search" v-if="defaultSearchField && defaultSearchField.length>0 && showMoreSearch" @click="moreSearchForList">查询</el-button>
                <el-button icon="el-icon-refresh" v-if="defaultSearchField && defaultSearchField.length>0 && showMoreSearch" @click="resetSearchConditon">重置</el-button>
                <el-switch
                v-if="selectedModel.modelType === 2 && showAggregateSearch"
                v-model="isReportAggregateSearch"
                @change="_initFormData"
                active-text="聚合查询"
                inactive-text="常规查询">
                </el-switch>
            </div>
            <div v-else class="btn-box">
              <!-- 
              <el-button class="btn-style" v-show="formBtnAuth.isShowExport" icon="iconfont icon-other-daochuquanbu" type="primary" v-preventReClick = "30000" title="导出全部" @click="dataExport()">&nbsp;&nbsp;导出全部</el-button>
              <el-button class="btn-style" v-show="formBtnAuth.isShowExport" icon="iconfont icon-other-daochu" type="primary" v-preventReClick = "30000" title="导出当前" @click="dataCurrentExport()">&nbsp;&nbsp;导出当前</el-button>
               -->
               <el-dropdown split-button v-show="formBtnAuth.isShowExport" v-preventReClick = "30000" type="primary" icon="el-icon-upload2" @command="exportData"  >
                导出
                <el-dropdown-menu slot="dropdown"> 
                  <el-dropdown-item icon="iconfont icon-other-daochu" command="current">导出当前</el-dropdown-item>
                  <el-dropdown-item icon="iconfont icon-other-daochuquanbu" command="all">导出全部</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-checkbox class="checkBox-style" v-if="isCanShowSummery" v-model="isShowSummary" @change="handleShowSummery"><el-tag size="mini">合计</el-tag></el-checkbox>
              <el-checkbox class="checkBox-style" v-model="hideOverflowTooltip" @change="handleHideOverflowTooltip"><el-tag size="mini">多行</el-tag></el-checkbox>
            </div>
            <div class="fulltext-search">
              <el-tooltip v-show="isModelForm && isViewFullTextAuth" class="item" effect="light" content="当输入关键字后，可以进行当前表单内所有字段进行的全文检索匹配" placement="top">
                <el-input @keyup.enter.native="handleFullTextSearch" placeholder="请输入内容" v-model="fullTextKey" @clear="handleFullTextSearch" clearable>  <i style="cursor: pointer;" @click.stop="handleFullTextSearch" slot="suffix" class="el-input__icon el-icon-search"></i></el-input>
              </el-tooltip>
            </div>
        </div>
        <div class="more-model-desc-search" v-if="showMoreSearch">
            <!-- <div v-for="(ob,index) in defaultSearchField" :key="index" class="more-model-desc-search-item">
                <SearchFieldItem  :key="ob.id" :field="ob" :formData="formData" />
            </div> -->
            <SearchConditionCommonField
                ref="searchConditonRight"
                v-if="showMoreSearch"
                :key="loadTimerSearchCondition"
                :conditionFields="defaultSearchField"
                :fullScreen="false"
                @searchForList="searchForList"
                @resetSearchConditon="resetSearchConditon"
            />
        </div>
        <div class="model-content">
            <div class="content-left">
               <!-- @rowDblclick="handelSelectRow" 原来设置的双击只读效果 -->
                <DynamicTable
                    ref="dynamicTable"
                    :selectedModel="selectedModel"
                    :showSummary="showSummary"
                    :tableColumns="tableColumns"
                    :fieldsList="fieldsList"
                    :subformTableColumns="subformTableColumns"
                    :tableData="pageData"
                    :pager="selectedModel.modelType===6?null:page"
                    :isLoading="tableLoading"
                    :isShowCheckbox="isModelForm"
                    :isSortable="true"
                    :isColumnDrop="true"
                    :isSubform="isSubform"
                    :isShowPageSizes="true"
                    :isShowOverflowTooltip="isShowOverflowTooltip"
                    :tableHeight="tableHeight"
                    :showMoreSearch="showMoreSearch"
                    :autoHeight="true"
                    :isShowProcessInfo="isShowProcessInfo"
                    :isViewApprovalInfo="isViewApprovalInfo"
                    :key="time"
                    :approvalList="approvalList"
                    :minuend="minuend"
                    :conditionLocalMap="conditionLocalMap"
                    @filterChange="chooseApprovalStatusField"
                    @rowClick="handelSelectRow"
                    @rowDblclick="handelDbSelectRow"
                    @changePageSize="queryFormDataByPageSize"
                    @changePage="queryFormData"
                    @searchOrderby="searchOrderby"
                    v-if="destoryTable"
                    @selectionChange="selectMore">
                </DynamicTable>
            </div>
            <el-dialog
                width="95%"
                top="1vh"
                append-to-body
                class="popEditModelDetail"
                :fullscreen=true
                :visible.sync="active"
                v-if="isShowModelDetail"
                @close="hideDialog">
                 <ModelDetail
                    v-if="isShowModelDetail"
                    :isShowForm="isShowForm"
                    :isReturnToNav="isReturnToNav"
                    ref="modelInstance"
                    :isRead="isRead"
                    :formInfo="formInfo"
                    @modelComplete="handleModelComplete"
                    @setIsShowForm="setIsShowForm"
                    @handleView="handleView"
                    @exportExcelData="exportExcelData"
                    @handleModelFormDelete="handleModelFormDelete"
                    @handleNavPage="handleNavPage"
                />
            </el-dialog>
            <el-dialog
                title="批量导入"
                top="1vh"
                append-to-body
                :visible.sync="isShowExcelData">
                <ExcelDataImport ref="excelInstance"  :isEmployeeExtendData="false" @importComplete="handleSearch" />
            </el-dialog>
            <el-dialog
                title="选择显示的字段"
                append-to-body
                top="4vh"
                v-if="isShowFilterField"
                :visible.sync="isShowFilterField">
                <!-- <SelectMultiple  ref="selectMultiple" :sourceOptions="sourceOptions" :allFields="allFields" :key="fieldTime"  :viewMode="'1'" v-if="isShowFilterField"/> -->
                <SelectMultiple  ref="selectMultiple" :sourceOptions="sourceOptions" :selectViewFields="selectViewFields" :allFields="allFields" :key="fieldTime"  :viewMode="'1'" v-if="isShowFilterField"/>
                <span slot="footer" class="dialog-footer">
                  <el-tooltip content="点击清空后，列表清除当前已选的字段。" effect="light" placement="top">
                    <el-button @click="clearViewField">清空</el-button>
                  </el-tooltip>
                  <el-tooltip content="点击全选，列表会选择当前列表所有字段。" effect="light" placement="top">
                    <el-button @click="selectAllViewField">全选</el-button>
                  </el-tooltip>
                  <el-tooltip content="点击全部展现后，列表会按当前表单配置好的所有可显示的字段进行默认配置。" effect="light" placement="top">
                    <el-button @click="setCurrentViewField">按最新表单配置</el-button>
                  </el-tooltip>
                  <el-tooltip content="点击保存配置后，对当前用户生效，每次查询当前表单列表时只显示配置过的字段。" effect="light" placement="top">
                    <el-button type="primary" @click="chooseViewField">保存配置</el-button>
                  </el-tooltip>
                </span>
            </el-dialog>
            <el-dialog
                title="设置查询条件"
                append-to-body
                top="4vh"
                custom-class="search-box"
                :visible.sync="isShowSearchConditon">
                <SearchCondition  :key="searchLoaderTime" v-if="isShowSearchConditon" ref="searchConditon" :conditionFields="conditionFields"  :isShowLeftModel="false"  @chooseSearchConditon="chooseSearchConditon"  />
                <span slot="footer" class="dialog-footer">
                    <div style="float: left"><el-tag effect="plain" type="danger" >可以将鼠标移动到列表上字段，选择字段后点击搜索图标进行查询</el-tag><i style="cursor: pointer;" class="el-icon-search" @click.stop="isShowSearchConditon = false"></i></div> 
                    <el-button @click="isShowSearchConditon = false">取 消</el-button>
                    <el-button @click="resetSearchConditon">重置</el-button>
                    <el-button type="primary" @click="chooseSearchConditon">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog
                :title="approvalTitle"
                width="90%"
                top="0vh"
                :fullscreen=true
                :visible.sync="isShowApprovalPop"
                append-to-body
                >
                <ApprovalPop ref="approvalPop" :instances="instances" :isInstance="isInstance" :approvalInfo="approvalInfo" :approvalTemplateObj="templateInfo" :btnMode="btnMode" :isRead="isRead" />
            </el-dialog>
            <el-dialog
                title="选择审批状态"
                append-to-body
                top="4vh"
                :visible.sync="isShowApprovalStatus">
                <SelectMultiple  ref="selectApprovalStatus" :sourceOptions="approvalStatusOptions"  />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="isShowApprovalStatus = false">取 消</el-button>
                    <el-button type="primary" @click="chooseApprovalStatusField">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog
                title="业务树关系图"
                custom-class="report-tree-dialog"
                class="business-report-tree"
                :fullscreen=true
                :visible.sync="isShowReportRelateTree"
                append-to-body
                >
                <ReportRelateTree ref="reportTreeList" :key="loadTimer" :modelId="searchParams.modelId" :formId="searchParams.formId" :isAllData="true"/>
            </el-dialog>
             <el-dialog
                title=""
                :visible.sync="isShowOrgTreeDialog"
                :fullscreen = true
                append-to-body
                >
                <VueOrgTree ref="reportOrgTree" :key="loadTimerReport" :treeData="treeOrgData" :hideAllBtn="false" @modelComplete="handleModelReportComplete"/>
            </el-dialog>
            <el-dialog
                title="数据分布"
                top="4vh"
                width="80vw"
                custom-class="form-show-map"
                :visible.sync="showDataMap"
                v-if="showDataMap"
                append-to-body>
                <ShowMaps
                    ref="showDataMaps"
                    v-if="showDataMap"
                    :mapsData="mapsData"
                    :locationFieldArry="locationFieldArry"
                    @handleNavModelFormEdit="handleNavModelFormEdit"
                    />
            </el-dialog>
        </div>
    </div>
    <UserOrgPop  :isShowUserOrg='isShowProcessUserOrg' :multiple='true' :selectedUser="selectedProcessUser" ref="showProcessUserOrg" @nodeClick="sendMessageToUser" />
    <el-drawer
        title="常用搜索"
        size="320px"
        custom-class="searchConditonRight"
        :visible.sync="drawer"
        v-if="drawer"
        >
        <SearchConditionCommonField
            ref="searchConditonRight"
            v-if="drawer"
            :key="loadTimerSearchCondition"
            :conditionFields="defaultSearchField"
            :fullScreen="false"
            @searchForList="searchForList"
            @resetSearchConditon="resetSearchConditon"
        />
    </el-drawer>
</div>
</template>

<script>
    import ReportRelateTree from '@/components/ReportRelateTree';
    import ModelDetail from './ModelDetail';
    import ExcelDataImport from './ExcelDataImport';
    import SelectMultiple from '@/components/SelectMultiple';
    import SearchCondition from '@/components/SearchCondition';
    import SideLeftTree from '@/components/SideLeftTree';
    import VueOrgTree from '@/components/VueOrgTree';
    import ShowMaps from '@/components/FieldProps/ShowMaps';
    import SearchConditionCommonField from '@/components/SearchCondition/SearchConditionCommonField';
    import { API_EXPORT_MODEL_FORM_EXCEL,
        API_EXPORT_MODEL_EXPORT_EXCEL_BY_EXPORTID,
        CONST_PERMISSION_BUSINESS_DELETE_MODEL_RECORD_BTN,
        CONST_PERMISSION_BUSINESS_MODIFIED_MODEL_RECORD_BTN,
        CONST_PERMISSION_BUSINESS_EXPORT_BUSINESS_FORM_DATA_BTN,
        CONST_PERMISSION_BUSINESS_IMPORT_BUSINESS_FORM_DATA_BTN,
        CONST_PERMISSION_BUSINESS_SYN_PROCESS_DATA_BTN,
        CONST_PERMISSION_BUSINESS_ADD_MODEL_RECORD_BTN,
        CONST_PERMISSION_BUSINESS_APPLICATION_CONFIG
    } from '@/common/constants';
    import { isEmpty, cloneDeep } from 'lodash';
    import { getCrossCountFieldCnt, updCrossCountFieldData, getApprovalInstanceDetail, getFormConfigs, getModelFormReportList, deleteAllTempTable,
        getModelFormInstanceById, saveAppModelForm, delModelFormInstance, sendMessageToUser, getCustomFormRuleConfig, updRPARuleData,
        syncProcessFormData, getFormFieldListByIds, getExcelDataExportId, updateUserFormViewField, getModelFormReportOrgTree, checkDataLegitimacy } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import SearchFieldItem from '@/components/SearchCondition/SearchFieldItem';

    export default {
        mixins: [ mixinsNav ],
        components: {
            ReportRelateTree,
            ModelDetail,
            ExcelDataImport,
            SelectMultiple,
            SearchCondition,
            SideLeftTree,
            VueOrgTree,
            ShowMaps,
            SearchFieldItem,
            SearchConditionCommonField
        },
        data () {
            return {
                showMoreSearch: false,
                showCrossCount: false,
                treeOrgData: {},
                loadTimerReport: '',
                isShowOrgTreeDialog: false,
                formDataId: '', // 单条数据的导出
                hasLinkField: false, // 是否有关联字段
                loadTimer: '',
                isShowReportRelateTree: false,
                isShowSummary: false,
                isCanShowSummery: false, // 是否可以显示合计行
                isFilterDuplicateData: false,
                isCollapse: true,
                leftTitleFlag: true,
                needSumData: false, // 是否将汇总值一起导出
                showSummary: false, // 是否要显示求和
                hideOverflowTooltip: false,
                isViewProcessInfo: false, // 是否显示关联流程明细
                isViewApprovalInfo: false, // 是否显示审批状态和审批详情
                isShowProcessInfo: false, // 是否显示流程
                isShowOverflowTooltip: true,
                unDelNums: '', // 不可删除的数据序号，逗号隔开
                isHasUNDel: false,
                moreIds: '', // 多选IDS字符串
                templateInfo: {
                    id: '',
                    templateName: '',
                    busiType: '',
                    busiTypeName: '',
                    remarks: '',
                    selectedUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    templateState: null,
                    forms: [],
                    users: [],
                    dataOperate: {
                        dataSource: 2,
                        forms: []
                    },
                    parentApprovalId: '',
                    mainApprovalId: ''
                },
                isRead: false,
                btnMode: 0, // 0申请-草稿 1审批
                selectedRowId: '',
                isInstance: false,
                instances: {
                    id: '',
                    formObj: {}
                },
                approvalInfo: {
                    approvalRemarks: '',
                    selectedCopyUserIds: '',
                    selectedCopyUserNames: ''
                },
                approvalInstanceList: [],
                isShowApprovalPop: false,
                approvalTitle: '查看审批详情',
                tableHeight: this.fullScreen ? '560' : '520',
                isSubform: false, // 是否包含子表单
                isModelForm: true, // 是否模型表单
                tableLoading: false,
                isShowForm: false,
                idStr: '',
                printStr: '',
                isShowModelDetail: false,
                isShowExcelData: false,
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                searchParams: {
                    modelId: '',
                    name: '',
                    isShowProcess: false,
                    selectedFields: '',
                    searchCondition: [],
                    selectedApprovalStatus: '',
                    selectedMonthStr: ''
                },
                tableColumns: [],
                fieldsList: [],
                allTableColumns: [],
                subformTableColumns: [],
                pageData: [],
                active: false, // 是否显示数据编辑侧滑弹窗
                formInfo: {},
                downloadUrl: '',
                isShowFilterField: false,
                sourceOptions: [],
                allFields: [],
                selectViewFields: [],
                oldSelectedModel: {},
                isRefreshSel: false,
                isRefreshCondition: false,
                isShowSearchConditon: false,
                conditionFields: [],
                isShowApprovalStatus: false,
                isApprovalForm: false,
                approvalList: [],
                isShowDown: false, // 是否单条数据显示下载按钮，默认false
                isInit: true,
                approvalStatusOptions: [{id: '0', label: '草稿'}, {id: '1', label: '审批中'}, {id: '2', label: '通过'}, {id: '3', label: '驳回'}, { id: 'ALL_SELECT', label: 'ALL' }],
                permission: {
                    deleteModelRecordBtn: [
                        CONST_PERMISSION_BUSINESS_DELETE_MODEL_RECORD_BTN
                    ],
                    modifiedModelRecordBtn: [
                        CONST_PERMISSION_BUSINESS_MODIFIED_MODEL_RECORD_BTN
                    ],
                    exportBusinessFormDataBtn: [
                        CONST_PERMISSION_BUSINESS_EXPORT_BUSINESS_FORM_DATA_BTN
                    ],
                    importBusinessFormDataBtn: [
                        CONST_PERMISSION_BUSINESS_IMPORT_BUSINESS_FORM_DATA_BTN
                    ],
                    synProcessDataBtn: [
                        CONST_PERMISSION_BUSINESS_SYN_PROCESS_DATA_BTN
                    ],
                    addModelRecordBtn: [
                        CONST_PERMISSION_BUSINESS_ADD_MODEL_RECORD_BTN
                    ],
                    isShowApplicationConfig: [
                        CONST_PERMISSION_BUSINESS_APPLICATION_CONFIG
                    ]
                },
                time: new Date().getTime(),
                fieldTime: '',
                searchLoaderTime: new Date().getTime(),
                destoryTable: true,
                showMaps: false,
                showDataMap: false,
                mapsData: [],
                locationFieldArry: [],
                canChecked: false,
                selectedMonth: '',
                selectedMonthStr: '',
                pickerOptions: {
                    disabledDate (time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '本月',
                        onClick (picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    }, {
                        text: '今年至今',
                        onClick (picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近六个月',
                        onClick (picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                isViewTerminalStatus: false,
                isShowProcessUserOrg: false,
                selectedProcessUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                defaultSearchField: [],
                showCollapse: false,
                formData: {},
                drawer: false,
                showRPATrigger: false,
                loadTimerSearchCondition: false,
                searchConditionExt: null,
                isReportAggregateSearch: false,
                showAggregateSearch: false,
                cachetableColumns: [],
                reportLeftJoinMode: true,
                conditionLocalMap: new Map(),
                fullTextKey: '',
                isViewFullTextAuth: false,
                isManageMode: false // 是否应用数据管理模式，true的话放开只读字段
            };
        },
        props: {
            selectedModel: {
                type: Object
            },
            formBtnAuth: {// 表单按钮权限
                type: Object,
                default: function () {
                    return {
                        isShowView: true, // 查看
                        isShowAdd: true, // 新增
                        isShowEdit: true, // 修改
                        isShowDelete: true, // 删除
                        isShowImport: true, // 导入
                        isShowExport: true, // 导出
                        isShowSyn: true // 同步流程数据
                    };
                }
            },
            fullScreen: {
                type: Boolean,
                default: false
            },
            isNewPage: {
                type: Boolean,
                default: false
            },
            isReturnToNav: {// 为发起审批成功后，判断来自于新交互模式还是旧模式，默认旧模式
                type: Boolean,
                default: false
            },
            fromReport: {
                type: Boolean,
                default: false
            },
            isCollapseForInit: {
                type: Boolean,
                default: true
            },
            showLeft: {
                type: Boolean,
                default: true
            },
            minuend: {
                type: Number,
                default: 180
            },
            isShowAggregateList: {// 是否聚合表显示模式
                type: Boolean,
                default: false
            },
            isReportShowSummary: { // 报表是否显示合计
                type: Boolean,
                default: false
            }
        },
        created () {
            this.isCollapse = this.isCollapseForInit;// 初始化左侧收起展开
            if (this.isNewPage) { // 新页面引用
                this.time = new Date().getTime();
                // this._initFormData();
                this.getCrossCountFieldCnt();
                this.isRPAform();
            }
            this.showSummary = this.isReportShowSummary;
            this.clearConditionLocalMap();
            this.viewFullTextAuth();
        },
        methods: {
            handleConfigApplication () {
                let url = '/application/model-config';
                window.sessionStorage.setItem('currentOpenUrl', url);// 路由定位
                let param = {modelId: this.selectedModel.id, appId: this.selectedModel.fappId, appName: this.selectedModel.fappName};
                window.sessionStorage.setItem('openUrlParam', JSON.stringify(param));// 传递的参数
                window.sessionStorage.setItem('locationDesignAppId', this.selectedModel.fappId);// 进入应用设计时定位打开对应应用
                this.$router.push({ name: 'model-config', path: url, query: param });
                // if (this.isNewPage) {
                //     let url = '/application/model-config';
                //     sessionStorage.setItem('currentOpenUrl', url);// 路由定位
                //     let param = {modelId: this.selectedModel.id, appId: this.selectedModel.fappId, appName: this.selectedModel.fappName};
                //     sessionStorage.setItem('openUrlParam', JSON.stringify(param));// 传递的参数
                //     sessionStorage.setItem('locationDesignAppId', this.selectedModel.fappId);// 进入应用设计时定位打开对应应用
                //     this.$router.push({ name: 'model-config', path: url, query: param });
                // } else {
                //     this.destoryTable = false;
                //     sessionStorage.setItem('locationDesignAppId', this.selectedModel.appId);// 进入应用设计时定位打开对应应用
                //     this.navConfigApplication(this.selectedModel.fappId, this.selectedModel.fappName, this.selectedModel.id);
                // }
            },
            async getCrossCountFieldCnt () {
                let data = await getCrossCountFieldCnt({formId: this.selectedModel.formId});
                if (data) {
                    this.showCrossCount = data.cnt > 0;
                }
            },
            async isRPAform () {
                let param = {formId: this.selectedModel.formId, ruleMode: 1};
                let res = await getCustomFormRuleConfig(param);
                if (res && res.state === 'success') {
                    let saveRule = res.formRule;
                    if (saveRule.length > 0) {
                        this.showRPATrigger = true;
                    }
                }
            },
            async _initFormData () {
                if (this.isReportAggregateSearch) {
                    this.isRefreshCondition = true;
                    this.cachetableColumns = cloneDeep(this.tableColumns);
                }
                this.renderFormList(this.selectedModel);
            },
            queryFormData ({currentPage}, type) {
                this.isInit = false;
                this.page.currentPage = currentPage;
                this.selectedModel.resetPage = false;
                this.renderFormList(this.selectedModel, type);
            },
            queryFormDataByPageSize ({pageSize}) {
                this.isInit = false;
                this.page.pageSize = pageSize;
                this.selectedModel.resetPage = false;
                this.renderFormList(this.selectedModel);
            },
            searchOrderby (searchItem) {
                if (!Array.isArray(searchItem)) {
                    this.searchParams.searchCondition = [];
                    this.searchParams.searchCondition.push(searchItem);
                } else {
                    let searchItemMap = new Map();
                    if (!isEmpty(searchItem)) {
                        searchItem.forEach(item => {
                            searchItemMap.set(item.id, item);
                        });
                    }
                    let searchCondition = [];
                    if (!isEmpty(this.conditionLocalMap)) {
                        for (let [key, value] of this.conditionLocalMap) {
                            if (searchItemMap.has(key)) {
                                searchCondition.push(searchItemMap.get(key));
                                searchItemMap.delete(key);
                            } else {
                                searchCondition.push(value);
                            }
                        }
                    }
                    this.searchParams.searchCondition = searchCondition;
                }
                this.queryFormData(1);
            },
            // async renderFormList (model, isInitSearch) {
            //     this.destoryTable = true;
            //     this.canChecked = true;
            //     if (this.oldSelectedModel && this.oldSelectedModel.id !== model.id) {
            //         this.oldSelectedModel = model;
            //         this.searchParams.selectedFields = '';
            //         this.isRefreshSel = true;
            //         this.isRefreshCondition = true;
            //         this.searchParams.searchCondition = [];
            //         this.searchParams.selectedApprovalStatus = '';// 初始化审批状态查询条件
            //         // this.isSubform=false;
            //         this.sourceOptions = [];
            //     }
            //     this.selectedModel = model;
            //     if (this.selectedModel.modelType > 1) {
            //         this.isModelForm = false;
            //     } else {
            //         this.isModelForm = true;
            //     }
            //     this.tableColumns = [];
            //     this.fieldsList = [];
            //     this.isSubform = false;
            //     this.tableLoading = true;
            //     this.searchParams.modelId = model.id;
            //     this.searchParams.formId = model.formId;
            //     this.searchParams.modelType = model.modeType;
            //     this.searchParams.isFilterDuplicateData = this.isFilterDuplicateData;
            //     if (this.selectedMonth && this.fromReport) {
            //         this.searchParams.selectedMonthStr = this.selectedMonth[0] + ',' + this.selectedMonth[1];
            //     }
            //     let formData = await getModelFormReportList(Object.assign({}, {
            //         currentPage: this.page.currentPage,
            //         pageSize: this.page.pageSize
            //     }, this.searchParams));
            //     if (formData && formData.otherData && formData.otherData.searchCondition) {
            //         this.conditionFields = JSON.parse(formData.otherData.searchCondition);
            //     }
            //     this.pageData = [];
            //     if (formData.data) {
            //         let tableDatas = [];
            //         formData.data.forEach(item => {
            //             let jsonObj = JSON.parse(item);
            //             tableDatas.push(jsonObj);
            //         });
            //         this.pageData = tableDatas;
            //     }
            //     if (formData.otherData.tableColumns) {
            //         this.tableColumns = [];
            //         let _tableColumns = formData.otherData.tableColumns;
            //         this.allTableColumns = cloneDeep(_tableColumns);
            //         _tableColumns.forEach(item => {
            //             if (item.type !== 'divider') { // 隐藏分割线
            //                 this.tableColumns.push(item);
            //             }
            //         });
            //     }
            //     if (formData.otherData.fieldsList) {
            //         this.fieldsList = formData.otherData.fieldsList;
            //         for (let i = 0; i < this.fieldsList.length; i++) {
            //             let cur = this.fieldsList[i];
            //             if (cur.type === 'location') {
            //                 this.showMaps = true;
            //                 this.locationFieldArry.push(cur);
            //             }
            //         }
            //     }
            //     if (isInitSearch) {
            //         this.$emit('refreshSearchConditon', this.tableColumns);
            //     }
            //     this.subformTableColumns = formData.otherData.subformTableColumns;
            //     // 如果是初次查询，需要获取isApprovalForm值，否则按照状态查询，则不需要重新赋值
            //     if (this.isInit) {
            //         this.isApprovalForm = formData.otherData.isApprovalForm;
            //     }
            //     if (formData.otherData.approvalList) {
            //         this.approvalList = formData.otherData.approvalList;
            //     }
            //     this.isShowDown = formData.otherData.isShowDown;
            //     if (this.$refs.dynamicTable) {
            //         this.$refs.dynamicTable.setMergeSpanArr(this.pageData);
            //     }
            //     this.isSubform = this.getIfSubform(formData.otherData.tableColumns);
            //     this.page = {
            //         currentPage: formData.currentPage,
            //         pageSize: formData.pageSize,
            //         totalPageNum: formData.totalPageNum
            //     };
            //     this.tableLoading = false;

            //     // 是否要显示合计行
            //     this.filterSumTableColumns();
            //     // 更新table高度  dynamicTable
            //     this.canChecked = false;
            //     this.time = new Date().getTime();
            // },
            getIfSubform (tableColumns) {
                let isSubform = false;
                for (var i = 0; i < tableColumns.length; i++) {
                    // 判断是否含有子表单列
                    if (tableColumns[i].subcolumn) {
                        isSubform = true;
                        break;
                    }
                }
                return isSubform;
            },
            async handleNavModelFormEdit (row) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.formInfo = await getModelFormInstanceById(row.id);
                loading.close();
                if (this.formInfo) {
                    this.formInfo.formId = this.selectedModel.formId;
                    this.formInfo.modelName = this.selectedModel.modelName;
                    this.formInfo.appName = this.selectedModel.fappName;
                    this.formInfo.remarks = this.selectedModel.remarks;
                    this.formInfo.modelType = this.selectedModel.modelType;
                    this.formInfo.isManageMode = this.isManageMode;
                    this.isShowModelDetail = true;
                    this.isShowForm = false;
                    this.isRead = false;
                    setTimeout(() => { // 调用子组件的方法
                        this.$refs.modelInstance.loadFormData(this.formInfo, this.formBtnAuth, row, this.isShowDown);
                    }, 0);
                }
                this.active = true;
            },
            handleModelFormDelete (row) {
                this.$confirm(`您确定要删除当前数据吗？被删除的数据不会被恢复。`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    await delModelFormInstance(row.id);
                    await this.queryFormData(this.page);
                    this.active = false;
                }).catch(() => {});
            },
            async handleModelComplete (model) {
                // let res = await this.checkDataLegitimacy(model);
                // if (res) {
                //     const loading = this.$loading({
                //         lock: true,
                //         text: 'Loading',
                //         spinner: 'el-icon-loading',
                //         background: 'rgba(0, 0, 0, 0.7)'
                //     });
                //     try {
                //         model.modelId = this.selectedModel.id;
                //         await saveAppModelForm(this.selectedModel.id, model);
                //         await this.queryFormData(this.page);
                //         this.active = false;
                //     } catch (error) {
                //         console.error('保存表单数据异常：', error);
                //     } finally {
                //         loading.close();
                //     }
                // }
                // console.log(222);
                let values = model.forms[0].values;
                let formId = model.forms[0].formId;
                let modelId = model.modelId;
                let param = {values: values, formId: formId, modelId: modelId, modelType: this.selectedModel.modelType};
                let res = await checkDataLegitimacy(param);
                if (res.state === 'success') {
                    if (res.warnFlag) {
                        this.$confirm('与系统中已有的数据相似度达【' + res.similarity + '%】,是否继续保存？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async (ret) => {
                            this.saveAppModelForm(model);
                        }).catch(() => {});
                    } else {
                        this.saveAppModelForm(model);
                    }
                    return true;
                } else {
                    if (res.msg) {
                        this.$message.error(res.msg);
                    } else {
                        this.$message.error('数据不合法');
                    }
                    return false;
                }
            },
            async saveAppModelForm (model) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    model.modelId = this.selectedModel.id;
                    await saveAppModelForm(this.selectedModel.id, model);
                    await this.queryFormData(this.page);
                    this.active = false;
                } catch (error) {
                    console.log(error);
                    loading.close();
                    console.error('保存表单数据异常：', error);
                } finally {
                    loading.close();
                }
            },
            async checkDataLegitimacy (model) {
                let values = model.forms[0].values;
                let formId = model.forms[0].formId;
                let modelId = model.modelId;
                let param = {values: values, formId: formId, modelId: modelId, modelType: this.selectedModel.modelType};
                let res = await checkDataLegitimacy(param);
                if (res.state === 'success') {
                    return true;
                } else {
                    if (res.msg) {
                        this.$message.error(res.msg);
                    } else {
                        this.$message.error('数据不合法');
                    }
                    return false;
                }
            },
            async handleModelReportComplete (model) {
                await saveAppModelForm(model.modelId, model);
                this.isShowOrgTreeDialog = false;
                await this.queryFormData(this.page);
            },
            switchAddFormData () {
                this.$emit('switchMode', 2);
            },
            handleFullScreen () {
                this.$emit('handleFullScreen');
            },
            handleSearch () {
                this.isShowExcelData = false;
                this.queryFormData(this.page);
            },
            async dataImport () {
                this.$nextTick(function () {
                    setTimeout(() => {
                        let param = {};
                        param.modelId = this.selectedModel.id;
                        setTimeout(() => { // 调用子组件的方法
                            this.$refs.excelInstance.initParam(param);
                        }, 0);
                        this.isShowExcelData = true;
                    }, 0);
                });
            },
            exportData (target) {
                if (target === 'all') { // 导出全部
                    this.dataExport();
                } else if (target === 'current') { // 导出当前
                    this.dataCurrentExport();
                }
            },
            async dataExport () {
                let url = `${API_EXPORT_MODEL_FORM_EXCEL}`;
                url = url + '&reportLeftJoinMode=' + this.searchParams.reportLeftJoinMode;
                if (this.showSummary) {
                    this.$confirm('是否将汇总值一起导出', '提示', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning'
                    }).then(() => {
                        this.needSumData = true;
                        if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                            this.downloadAllLink(url);
                        } else {
                            this.download(url);
                        }
                    }).catch(() => {
                        this.needSumData = false;
                        this.download(url);
                    });
                } else {
                    this.needSumData = false;
                    if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                        this.downloadAllLink(url);
                    } else {
                        this.download(url);
                    }
                }
            },
            async dataCurrentExport () {
                let url = `${API_EXPORT_MODEL_FORM_EXCEL}`;
                url = url + '&reportLeftJoinMode=' + this.searchParams.reportLeftJoinMode;
                if (this.showSummary) {
                    this.$confirm('是否将汇总值一起导出', '提示', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning'
                    }).then(() => {
                        this.needSumData = true;
                        if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                            this.$confirm('表单中有关联字段，是否将关联字段的全部显示字段信息一起导出', '提示', {
                                confirmButtonText: '否',
                                cancelButtonText: '是',
                                type: 'warning'
                            }).then(() => {
                                this.download(url, false, true);
                            }).catch(() => {
                                url = url.replace('needLinkSelectField=false', 'needLinkSelectField=true');
                                this.download(url, true, true);
                            });
                        } else {
                            this.download(url, false, true);
                        }
                    }).catch(() => {
                        this.needSumData = false;
                        this.download(url, false, true);
                    });
                } else {
                    this.needSumData = false;
                    if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                        if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                            this.$confirm('表单中有关联字段，是否将关联字段的全部显示字段信息一起导出', '提示', {
                                confirmButtonText: '否',
                                cancelButtonText: '是',
                                type: 'warning'
                            }).then(() => {
                                this.download(url, false, true);
                            }).catch(() => {
                                url = url.replace('needLinkSelectField=false', 'needLinkSelectField=true');
                                this.download(url, true, true);
                            });
                        } else {
                            this.download(url, false, true);
                        }
                    } else {
                        this.download(url, false, true);
                    }
                }
            },
            downloadAllLink (url) {
                this.$confirm('表单中有关联字段，是否将关联字段的全部显示字段信息一起导出', '提示', {
                    confirmButtonText: '否',
                    cancelButtonText: '是',
                    type: 'warning'
                }).then(() => {
                    this.download(url);
                }).catch(() => {
                    url = url.replace('needLinkSelectField=false', 'needLinkSelectField=true');
                    this.download(url, true);
                });
            },
            async download(url, needLinkSelectField = false, current) {
                let selectedMonthStr = '';
                if (this.selectedMonth && this.fromReport) {
                    selectedMonthStr = this.selectedMonth[0] + ',' + this.selectedMonth[1];
                }

                let newSearchConditionExt = cloneDeep(this.searchParams);
                if (!this.oldSelectedModel.root && this.oldSelectedModel.leftTreeMode) {
                    newSearchConditionExt.searchCondition = newSearchConditionExt.searchCondition.concat(this.searchConditionExt);
                }
                console.log(this.reportLeftJoinMode);
                let param = {
                    modelId: this.selectedModel.id,
                    selectedFields: this.searchParams.selectedFields,
                    searchCondition: newSearchConditionExt.searchCondition ? JSON.stringify(newSearchConditionExt.searchCondition) : '[]',
                    isApprovalForm: this.isApprovalForm,
                    needSumData: this.needSumData,
                    needLinkSelectField: needLinkSelectField,
                    selectedApprovalStatus: this.searchParams.selectedApprovalStatus,
                    isViewApprovalInfo: this.searchParams.isViewApprovalInfo,
                    formDataId: this.formDataId, // 单条数据导出需要数据id
                    isCurrentExport: current === true ? 1 : 0,
                    selectedMonthStr: selectedMonthStr,
                    reportLeftJoinMode: this.reportLeftJoinMode
                };
                if (current) {
                    param.moreIds = this.moreIds;
                    param.page = JSON.stringify(this.page);
                }
                param.reportAggregateSearch = this.isReportAggregateSearch;
                let res = await getExcelDataExportId(param);
                this.formDataId = '';
                if (res && res.data) {
                    url = `${API_EXPORT_MODEL_EXPORT_EXCEL_BY_EXPORTID}`;
                    url = url.replace(':exportId', res.data);
                } else {
                    let condition = encodeURIComponent(JSON.stringify(this.searchParams.searchCondition));
                    url = url.replace(':modelId', this.selectedModel.id).replace(':selectedFields', this.searchParams.selectedFields).replace(':searchCondition', condition).replace(':isApprovalForm', this.isApprovalForm).replace(':needSumData', this.needSumData);
                }
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
            },
            download_bak (url) {
                let condition = encodeURIComponent(JSON.stringify(this.searchParams.searchCondition));
                url = url.replace(':modelId', this.selectedModel.id).replace(':selectedFields', this.searchParams.selectedFields).replace(':searchCondition', condition).replace(':isApprovalForm', this.isApprovalForm).replace(':needSumData', this.needSumData);
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
            },
            async handleFilterCondition () {
                this.isShowSearchConditon = false;
                if (!isEmpty(this.conditionLocalMap)) {
                    this.conditionFields = [];
                    for (let [key, value] of this.conditionLocalMap) {
                        this.conditionFields.push(value);
                    }
                } else if (this.isRefreshCondition || this.searchParams.searchCondition.length < 1) {
                    let columns = cloneDeep(this.tableColumns);
                    if (this.isReportAggregateSearch) {
                        columns = this.cachetableColumns;
                    }
                    let idArr = [];
                    columns.forEach(item => {
                        idArr.push(item.id);
                    });
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.conditionFields = await getFormFieldListByIds(idArr.join(','));
                    loading.close();
                    this.isRefreshCondition = false;
                } else {
                    this.conditionFields = this.searchParams.searchCondition;
                }
                this.isShowSearchConditon = true;
                this.searchLoaderTime = new Date().getTime();
            },
            handleFilterField () {
                this.isShowFilterField = true;
                if (this.isRefreshSel) {
                    let fieldsMap = new Map();
                    this.sourceOptions = [];
                    this.selectViewFields = [];
                    this.allFields = [];
                    let tableColumnsView = cloneDeep(this.tableColumns);
                    tableColumnsView.forEach((field) => {
                        if (field.id !== 'approvalStatus' && field.id !== 'approvalResultDetail' && field.id !== 'num' && field.id !== 'processInstanceName') {
                            this.sourceOptions.push(field);
                            this.selectViewFields.push(field.id);
                            fieldsMap.set(field.id, field);
                        }
                    });
                    for (let i = 0; i < this.fieldsList.length; i++) {
                        this.fieldsList[i].label = this.fieldsList[i].name;
                        this.allFields.push(this.fieldsList[i]);
                    }
                    // this.sourceOptions.unshift({ id: 'ALL_SELECT', label: 'ALL' });
                    this.allFields.unshift({ id: 'ALL_SELECT', label: 'ALL(全部选择)' });
                    if (this.selectedModel.modelType === 0) {
                        if (!fieldsMap.has('appCreatedByName')) {
                            // this.sourceOptions.push({ id: 'appCreatedByName', label: '应用录入人' });
                            // this.sourceOptions.push({ id: 'appCreatedByDate', label: '应用录入时间' });
                            this.allFields.push({ id: 'appCreatedByName', label: '应用录入人' });
                            this.allFields.push({ id: 'appCreatedByDate', label: '应用录入时间' });
                        }
                        // 因为多了流程选择，所以在这里去掉了
                    }
                    setTimeout(() => { // 调用子组件的方法
                        this.$refs.selectMultiple.initFields();// 每次切换model时清空显示字段
                    }, 100);
                    this.isRefreshSel = false;
                }
            },
            async chooseViewField () {
                this.isShowFilterField = false;
                this.isRefreshSel = true;
                this.fieldTime = new Date().getTime();
                let selectedFields = this.$refs.selectMultiple.getSelectFields();
                this.searchParams.selectedFields = selectedFields;
                this.queryFormData(this.page);
            },
            async clearViewField () { // 清空
                this.sourceOptions = [];
                this.selectViewFields = [];
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.selectMultiple.initFields();// 每次切换model时清空显示字段
                }, 100);
            },
            async selectAllViewField () { // 全选
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.selectMultiple.selectAll('ALL_SELECT');
                }, 100);
            },
            async setCurrentViewField () { // 按最新配置
                let param = {formId: this.selectedModel.formId, modelId: this.selectedModel.id};
                let res = await updateUserFormViewField(param);
                if (res.state === 'success') {
                    this.fieldTime = new Date().getTime();
                    // let selectedFields = this.$refs.selectMultiple.getSelectFields();
                    this.searchParams.selectedFields = null;
                    this.queryFormData(this.page, true);
                    this.isShowFilterField = false;
                    this.isRefreshSel = true;
                }
            },
            async resetSearchConditon () {
                let columns = cloneDeep(this.tableColumns);
                let idArr = [];
                columns.forEach(item => {
                    idArr.push(item.id);
                });
                this.conditionFields = await getFormFieldListByIds(idArr.join(','));
                this.page.currentPage = 1;
                if (this.showMoreSearch) {
                    let resetArr = [];
                    this.conditionFields.forEach(item => {
                        this.defaultSearchField.forEach(selItem => {
                            if (selItem.id === item.id) {
                                resetArr.push(item);
                            }
                        });
                    });
                    this.defaultSearchField = cloneDeep(resetArr);
                    this.loadTimerSearchCondition = new Date().getTime();
                }
                this.isRefreshCondition = true;
                this.searchLoaderTime = new Date().getTime();
            },
            async chooseSearchConditon () {
                this.isShowSearchConditon = false;
                let searchCondition = this.$refs.searchConditon.getSearchCondition();
                // this.searchParams.searchCondition = searchCondition;
                this.page.currentPage = 1;
                // this.queryFormData(this.page);
                this.searchForList(searchCondition);
                if (!isEmpty(searchCondition)) {
                    this.conditionLocalMap = new Map();
                    searchCondition.forEach(element => {
                        if (!this.conditionLocalMap.has(element.id)) {
                            this.conditionLocalMap.set(element.id, element);
                        }
                    });
                }
            },
            async searchForList (searchCondition, isInitSearch) {
                this.isShowSearchConditon = false;
                // this.drawer = false;
                for (let i = 0; i < searchCondition.length; i++) {
                    let cur = searchCondition[i];
                    if (cur.type === 'link') {
                        cur.searchFieldId = cur.id + '-view';
                    }
                }
                this.searchParams.searchCondition = searchCondition;
                this.selectedModel.resetPage = true;
                this.renderFormList(this.selectedModel, isInitSearch);
            },
            setIsShowForm (status) {
                this.isShowForm = status;
            },
            async syncProcessData () {
                this.tableLoading = true;
                let param = {targetFormId: this.selectedModel.formId, targetModelId: this.selectedModel.id};
                await syncProcessFormData(param);
                await this.queryFormData(this.page);
                this.tableLoading = false;
            },
            hideDialog () {
                this._initFormData();
                this.active = false;
                this.isShowModelDetail = false;
                this.$refs.modelInstance.clearTimeOut();
            },
            async handelSelectRow (params) {
                if (this.isModelForm) {
                    this.handleNavModelFormEdit(params.row);
                }
            },
            async handelDbSelectRow (params) {
                if (this.selectedModel.modelType === 2) { // 报表类型,点击双击查看百川金字塔
                    // console.log(params.row);
                    this.showOrgTreeView(params.row);
                }
            },
            async handleView (rowInfo) {
                this.btnMode = 2;
                let row = await getApprovalInstanceDetail(rowInfo.approvalInstanceId);
                if (this.selectedRowId !== row.id) {
                    await this.initApprovalPop(row);
                }
                this.isRead = true;
                this.isShowApprovalPop = true;
            },
            async initApprovalPop (row) {
                this.selectedRowId = row.id;
                this.templateInfo = row;
                this.templateInfo.selectedUser = {};
                this.templateInfo.selectedUser.selectedUserIds = row.selectedUserIds;
                this.templateInfo.selectedUser.selectedUserNames = row.selectedUserNames;
                this.templateInfo.templateName = row.approvalName;
                this.templateInfo.busiType = row.approvalType;
                this.templateInfo.busiTypeName = row.approvalTypeName;
                this.instances.id = row.processInstanceId;
                this.isInstance = true;
                await this.initStruct(row);
                setTimeout(() => { // 默认回显值
                    this.$refs.approvalPop._initPage();
                }, 0);
            },
            async initStruct (row) {
                let formIds = [];
                row.forms.forEach(element => {
                    formIds.push(element.formId);
                });
                let formsMap = await getFormConfigs(formIds.join(','));
                this.instances.formObj = {};
                this.instances.formObj.structure = [];
                this.instances.formObj.instance = row.formValues;
                for (var key in formsMap) {
                    if (formsMap[key]) {
                        this.instances.formObj.structure.push(formsMap[key]);
                    }
                }
            },
            async exportExcelData(rowInfo) {
                let url = `${API_EXPORT_MODEL_FORM_EXCEL}`;
                let approvalInstanceId = rowInfo.approvalInstanceId;
                let formDataId = rowInfo.id;
                this.formDataId = formDataId;
                let condition = encodeURIComponent(JSON.stringify(this.searchParams.searchCondition));
                url = url.replace(':modelId', this.selectedModel.id).replace(':selectedFields', this.searchParams.selectedFields).replace(':searchCondition', condition).replace(':approvalInstanceId', approvalInstanceId).replace(':isApprovalForm', false).replace(':needSumData', false);
                url = url + '&formDataId=' + formDataId + '&reportLeftJoinMode=' + this.searchParams.reportLeftJoinMode;
                if (this.selectedModel.modelType < 2 && this.hasLinkField) {
                    this.$confirm('表单中有关联字段，是否将关联字段的全部显示字段信息一起导出', '提示', {
                        confirmButtonText: '否',
                        cancelButtonText: '是',
                        type: 'warning'
                    }).then(() => {
                        this.download(url);
                    }).catch(() => {
                        url = url.replace('needLinkSelectField=false', 'needLinkSelectField=true');
                        this.download(url);
                    });
                } else {
                    this.download(url);
                }
            },
            handleApprovalStatusFilter () {
                this.isShowApprovalStatus = true;
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.selectApprovalStatus.initFields();// 每次切换model时清空显示字段
                }, 100);
            },
            async chooseApprovalStatusField (approvalStatus) {
                // 改为列表头筛选触发
                this.searchParams.selectedApprovalStatus = approvalStatus;
                this.queryFormData(1);
            },
            selectMore (params) {
                this.isHasUNDel = params.isHasUNDel;
                this.moreIds = params.ids;
                this.unDelNums = params.unDelNums;
            },
            handleModelFormBatchDelete () {
                if (this.isHasUNDel) {
                    this.messageTip('第[' + this.unDelNums + ']条数据不可删除，请重新选择数据', 'warning');
                    return false;
                }
                if (this.moreIds) {
                    this.$confirm(`您确定要批量删除当前数据吗？被删除的数据不会被恢复。`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async (res) => {
                        await delModelFormInstance(this.moreIds);
                        await this.queryFormData(this.page);
                        this.active = false;
                    }).catch(() => {});
                } else {
                    this.messageTip('请先选择要删除的数据', 'warning');
                    return false;
                }
            },
            handleHideOverflowTooltip () {
                if (this.hideOverflowTooltip) {
                    this.isShowOverflowTooltip = false;
                } else {
                    this.isShowOverflowTooltip = true;
                }
            },
            handleShowSummery () {
                if (this.isShowSummary) {
                    this.showSummary = true;
                } else {
                    this.showSummary = false;
                }
                this.time = new Date().getTime();
            },
            handleViewProcessInfo () {
                this.searchParams.isShowProcess = false;
                let tableColumnsView = cloneDeep(this.tableColumns);
                let selectedFields = '';
                let num = 0;
                tableColumnsView.forEach((field) => {
                    if (field.id !== 'approvalStatus' && field.id !== 'approvalResultDetail' && field.id !== 'num' && field.id !== 'processInstanceName') {
                        if (num === 0) {
                            selectedFields = field.id;
                        } else {
                            selectedFields = selectedFields + ',' + field.id;
                        }
                        num++;
                    }
                });
                if (this.isViewProcessInfo) {
                    selectedFields = selectedFields + ',' + 'processInstanceName';
                    this.isShowProcessInfo = true;
                    this.searchParams.isShowProcess = true;
                } else {
                    this.isShowProcessInfo = false;
                }
                if (!this.isViewApprovalInfo) {
                    this.searchParams.selectedApprovalStatus = null;
                }
                this.searchParams.selectedFields = selectedFields;
                this.searchParams.isViewApprovalInfo = this.isViewApprovalInfo;
                this.searchParams.isViewTerminalStatus = this.isViewTerminalStatus;
                this.queryFormData(1);
            },
            async handleUpdCrossCountFieldData () {
                let loading = '';
                this.$confirm(`将会对当前表的所有数据的跨年统计属性字段值进行更新，您确定要执行该操作吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await updCrossCountFieldData({formId: this.selectedModel.formId});
                    this._initFormData();
                    loading.close();
                }).catch(() => {
                    loading.close();
                });
            },
            async handleRPATriggerData () {
                let loading = '';
                this.$confirm(`将会对当前表单设定的RPA规则进行数据动态生成，您确定要执行该操作吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await updRPARuleData({formId: this.selectedModel.formId});
                    this._initFormData();
                    loading.close();
                }).catch(() => {
                    loading.close();
                });
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            filterSumTableColumns () { // 过滤出需要求和的字段list
                this.isCanShowSummery = false;
                this.hasLinkField = false;
                // 将计算属性过滤出来
                this.tableColumns.forEach((mainItem, index) => {
                    if (mainItem.type === 'number' || mainItem.type === 'calculation') {
                        this.isCanShowSummery = true;
                    }
                    if (mainItem.type === 'subform') {
                        let subColumns = mainItem.subColumns;
                        subColumns.forEach((subItem) => {
                            if (subItem.type === 'number' || subItem.type === 'calculation') {
                                this.isCanShowSummery = true;
                            }
                        });
                    }
                    if (mainItem.type === 'link') {
                        this.hasLinkField = true;
                    }
                });
            },
            changeLeftTree (isCollapse) {
                this.$emit('collapseLeftSide', isCollapse, this.defaultSearchField);
            },
            changeLeftList () {
                this.isCollapse = true;
                this.$emit('setShowleftList', this.defaultSearchField);
                if (this.leftTitleFlag) {
                    this.leftTitleFlag = false;
                } else {
                    this.leftTitleFlag = true;
                }
            },
            async handelShowReportRelateTree () {
                // this.loadTimer = new Date().getTime();
                // setTimeout(() => {
                //     this.$refs.reportTreeList._initPage();
                // }, 0);
                // this.isShowReportRelateTree = true;
                this.messageTip('请先选择列表某一条数据后进行双击', 'warning');
            },
            showList () {
                this.$emit('swtitcList');
            },
            showNewMenuSearch () {
                this.$emit('showSearch');
            },
            handleNavPage () { // 审批流发起或保存成功返回处理逻辑
                this.active = false;
                this.isShowModelDetail = false;
                this.$emit('handleNavPage');
            },
            async showOrgTreeView (row) { // 点击报表界面数据弹出对应数据一对多的百川金字塔图
                this.isShowOrgTreeDialog = false;
                this.loadTimerReport = new Date().getTime();
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let formData = await getModelFormReportOrgTree(this.selectedModel.formId, row.id);
                loading.close();
                this.treeOrgData = {};
                if (formData && formData.data) {
                    let tableDatas = {};
                    formData.data.forEach(item => {
                        tableDatas = JSON.parse(item);
                    });
                    this.treeOrgData = tableDatas;
                }
    
                this.isShowOrgTreeDialog = true;
            },
            showMapsData () {
                this.showDataMap = true;
                this.mapsData = cloneDeep(this.pageData);
            },
            async sendMessageToPeople (command) { // 提醒人查看这些消息
                // if (command === 'systemPeople') { // 将所选消息逐条推送到所选人员绑定微信上
                //     setTimeout(() => { // 初始化
                //         this.$refs.showProcessUserOrg._initPage();
                //     }, 0);
                //     this.isShowProcessUserOrg = true;
                // } else if (command === 'formField') { // 将所选消息按照数据的人员字段推送到人员上面

                // }
                let dataArray = [];
                let moreIdArray = this.moreIds.split(',');
                for (let i = 0; i < moreIdArray.length; i++) {
                    let id = moreIdArray[i];
                    this.pageData.forEach(element => {
                        if (element.id === id) {
                            let dataItem = {
                                dataId: id,
                                dataDate: element['f703a76eed50407c8b8f57300bd9ea81'],
                                userName: element['d58e91c6546e4d55b191f581061635f8-user'],
                                sendDate: element['appCreatedByDate'],
                                userId: element['d58e91c6546e4d55b191f581061635f8'],
                                wagesPayable: element['da397642735a4dd2a261b2b82034f3f7'],
                                netSalary: element['259406c4dd6b48a8b589aaf0fe712be4']
                            };
                            dataArray.push(dataItem);
                        }
                    });
                }
                let param = {salaryData: JSON.stringify(dataArray)};
                let res = await sendMessageToUser(param);
                console.log(res);
            },
            async sendMessageToUser (selected) { // 流程负责人
                // this.selectedProcessUser = selected;
                // this.searchParams.selectedUserIds = this.selectedProcessUser.selectedUserIds;
                // this.searchParams.selectedUserNames = this.selectedProcessUser.selectedUserNames;
                // console.log(selected);
                // console.log(this.moreIds);
                if (this.moreIds === '') {
                    this.$message.error('请选择数据');
                } else {
                    if (selected.selectedUserIds === '') {
                        this.$message.error('请选择人员');
                    } else { // 表单数据推送给系统人员
                        // console.log(this.pageData);
                        let dataArray = [];
                        for (let i = 0; i < this.moreIds.length; i++) {
                            let id = this.moreIds[i];
                            this.pageData.forEach(element => {
                                if (element.id === id) {
                                    let dataItem = {
                                        dataId: id,
                                        dataDate: element['f703a76eed50407c8b8f57300bd9ea81'],
                                        userName: element['d58e91c6546e4d55b191f581061635f8-user'],
                                        sendDate: element['appCreatedByDate'],
                                        userId: element['d58e91c6546e4d55b191f581061635f8'],
                                        wagesPayable: element['da397642735a4dd2a261b2b82034f3f7'],
                                        netSalary: element['259406c4dd6b48a8b589aaf0fe712be4']
                                    };
                                    dataArray.push(dataItem);
                                }
                            });
                        }
                        let param = {userIds: selected.selectedUserIds, dataIds: this.moreIds};
                        let res = await sendMessageToUser(param);
                        if (res.state === 'success' && res.failedName !== '') {
                            this.$message.error(res.failedName + '的工资单推送失败');
                        } else {
                            this.$message.error('工资单推送失败');
                        }
                    }
                }
                // this.handleSearch();
            },
            async renderFormList(model, isInitSearch, searchConditionExt) {
                this.isManageMode = model.isManageMode;
                this.destoryTable = true;
                this.canChecked = true;
                if (model.resetPage) {
                    this.page = {
                        currentPage: 1,
                        pageSize: 10
                    };
                }
                if (this.oldSelectedModel && this.oldSelectedModel.id !== model.id) {
                    this.oldSelectedModel = model;
                    this.searchParams.selectedFields = '';
                    this.isRefreshSel = true;
                    this.isRefreshCondition = true;
                    this.searchParams.searchCondition = [];
                    this.searchParams.selectedApprovalStatus = '';// 初始化审批状态查询条件
                    // this.isSubform=false;
                    this.sourceOptions = [];
                    model.leftTreeMode = false;
                    if (!this.isShowAggregateList) { // 聚合表显示模式下需要传入查询条件
                        searchConditionExt = null;
                    }
                }
                if (this.isShowAggregateList && this.searchConditionExt) {
                    searchConditionExt = this.searchConditionExt;
                }
                this.selectedModel = model;
                if (this.selectedModel.modelType > 1) {
                    this.isModelForm = false;
                } else {
                    this.isModelForm = true;
                }
                this.tableColumns = [];
                this.fieldsList = [];
                this.isSubform = false;
                this.tableLoading = true;
                this.searchParams.modelId = model.id;
                this.searchParams.formId = model.formId;
                this.searchParams.modelType = model.modeType;
                this.searchParams.isFilterDuplicateData = this.isFilterDuplicateData;
                this.searchParams.reportLeftJoinMode = this.reportLeftJoinMode;
                this.searchParams.selectedMonthStr = '';
                if (this.selectedMonth && this.fromReport) {
                    this.searchParams.selectedMonthStr = this.selectedMonth[0] + ',' + this.selectedMonth[1];
                }
                let newSearchConditionExt;
                if (searchConditionExt && !isEmpty(searchConditionExt) && searchConditionExt.length > 0) {
                    let searchCondition = this.searchParams.searchCondition.concat(searchConditionExt);
                    newSearchConditionExt = cloneDeep(this.searchParams);
                    this.searchConditionExt = searchCondition;
                    newSearchConditionExt.searchCondition = this.searchConditionExt;
                } else {
                    newSearchConditionExt = cloneDeep(this.searchParams);
                    if (!model.root && model.leftTreeMode) {
                        newSearchConditionExt.searchCondition = newSearchConditionExt.searchCondition.concat(this.searchConditionExt);
                    }
                }
                newSearchConditionExt.currentPage = this.page.currentPage;
                newSearchConditionExt.pageSize = this.page.pageSize;
                newSearchConditionExt.isReportAggregateSearch = this.isReportAggregateSearch;
                newSearchConditionExt.fullTextKey = this.fullTextKey;
                let formData = await getModelFormReportList(Object.assign({}, {
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                }, newSearchConditionExt));
                if (formData && formData.otherData && formData.otherData.searchCondition) {
                    this.conditionFields = JSON.parse(formData.otherData.searchCondition);
                }
                if (formData && formData.otherData && formData.otherData.formReport) {
                    let aggregateReprotTableData = formData.otherData.formReport.aggregateReprotTableData;
                    if (aggregateReprotTableData) {
                        this.showAggregateSearch = true;
                    }
                }
                this.pageData = [];
                if (formData && formData.data) {
                    let tableDatas = [];
                    formData.data.forEach(item => {
                        let jsonObj = JSON.parse(item);
                        tableDatas.push(jsonObj);
                    });
                    this.pageData = tableDatas;
                }
                if (formData.otherData.tableColumns) {
                    this.tableColumns = [];
                    let _tableColumns = formData.otherData.tableColumns;
                    this.allTableColumns = cloneDeep(_tableColumns);
                    _tableColumns.forEach(item => {
                        if (item.type !== 'divider') { // 隐藏分割线
                            this.tableColumns.push(item);
                        }
                    });
                }
                if (formData.otherData.fieldsList) {
                    this.fieldsList = formData.otherData.fieldsList;
                    for (let i = 0; i < this.fieldsList.length; i++) {
                        let cur = this.fieldsList[i];
                        if (cur.type === 'location') {
                            this.showMaps = true;
                            this.locationFieldArry.push(cur);
                        }
                    }
                }
                if (isInitSearch) {
                    this.$emit('refreshSearchConditon', this.tableColumns);
                }
                this.subformTableColumns = formData.otherData.subformTableColumns;
                // 如果是初次查询，需要获取isApprovalForm值，否则按照状态查询，则不需要重新赋值
                if (this.isInit) {
                    this.isApprovalForm = formData.otherData.isApprovalForm;
                }
                if (formData.otherData.approvalList) {
                    this.approvalList = formData.otherData.approvalList;
                }
                this.isShowDown = formData.otherData.isShowDown;
                if (this.$refs.dynamicTable) {
                    this.$refs.dynamicTable.setMergeSpanArr(this.pageData);
                }
                this.isSubform = this.getIfSubform(formData.otherData.tableColumns);
                this.page = {
                    currentPage: formData.currentPage,
                    pageSize: formData.pageSize,
                    totalPageNum: formData.totalPageNum
                };
                this.tableLoading = false;

                // 是否要显示合计行
                this.filterSumTableColumns();
                // 更新table高度  dynamicTable
                this.canChecked = false;
                this.time = new Date().getTime();
            },
            eachSearchField (defaultSearchField) {
                this.defaultSearchField = defaultSearchField;
            },
            searchFieldData () {
                this.renderFormList(this.selectedModel, true, this.defaultSearchField);
            },
            collapseLeftSide (flag) {
                this.showCollapse = flag;
            },
            showSearchFieldData () {
                // this.drawer = true;
                this.showMoreSearch = !this.showMoreSearch;
            },
            moreSearchForList () {
                this.$refs.searchConditonRight.searchForList();
            },
            async clearCacheData () {
                let loading = '';
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await deleteAllTempTable({});
                this._initFormData();
                loading.close();
            },
            async changeJoinMode () { // 切换数据表连接模式
                this._initFormData();
            },
            clearConditionLocalMap () {
                if (!isEmpty(this.conditionLocalMap)) {
                    this.conditionLocalMap = new Map();
                    this.searchParams.searchCondition = [];
                    this.page.currentPage = 1;
                    this.queryFormData(1);
                }
            },
            handleFullTextSearch () {
                this.page.currentPage = 1;
                this.queryFormData(1);
            },
            viewFullTextAuth () {
                this.isViewFullTextAuth = false;
                let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                if (currentUserStr) {
                    let currentUserInfo = JSON.parse(currentUserStr);
                    let resources = currentUserInfo.resources;
                    if (resources) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i].resourceUrl === 'AllProcessInstanceData') { // 是否可以查看所有流程(使用它来进行分配全文检索的功能)
                                this.isViewFullTextAuth = true;
                                break;
                            }
                        }
                    }
                }
                console.log(this.isViewFullTextAuth);
            }
        }
    };
</script>

<style lang="less">
    .model-FormList {
        width: 100%;
        // height: 100%;
        overflow-y: auto;
        .el-button--small{
            padding: 8px 8px;
        }
        .el-collapse-item__wrap {
            padding: 0 20px;
        }
        .el-collapse {
            width: 100%;
        }
        .el-form {
            width: 95%;
        }
        .model-btns {
            height: 80px;
            padding: 0 10px 0 0;
        }
        .model-desc {
            min-height:40px;
            height: auto;
            line-height:26px;
            display: flex;
            justify-content: flex-end;
            border: 1px solid #f5f5f5;
            padding-top: 10px;
            border-bottom: none;
            padding-right: 10px;
            .form-search-tools{
                display: flex;
                justify-content: flex-end;
                flex: 1;
                .form-search-tools-item{
                    // width: 158px;
                    margin-left: 10px;
                    margin-right: 10px;
                    @media screen and (min-width: 1024px) and (max-width: 1366px) {
                       display: none;
                    }
                }
                .form-search-tools-btns{
                    .search-btn{
                        @media screen and (min-width: 1024px) and (max-width: 1366px) {
                        display: none;
                        }
                    }
                }
            }
            .form-btn-tools{
                padding-left: 20px;
                text-align: left;
                width: auto;
                padding-right: 20px;
                @media screen and (min-width: 1024px) and (max-width: 1366px) {
                    padding-left: 8px;
                }
                .el-button{
                    width: 36px;
                    height: 36px;
                    @media screen and (min-width: 1024px) and (max-width: 1366px) {
                        width: 30px;
                        height: 30px;
                    }
                }
            }
            .el-card__body {
                margin-top:-26px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
        }
        .model-content {
            flex: 1;
            display: flex;
            flex-direction: row;
            height: ~"calc(100% - 38px)";
            @media screen and (min-width: 1024px) and (max-width: 1366px) {
               height: ~"calc(100% - 60px)";
            }
            .el-table .sort-caret.ascending {
                border-bottom-color: #c0c4cc;
                top: 1px;
            }
            .el-table .sort-caret.descending {
                border-top-color: #c0c4cc;
                bottom: 1px;
            }
            .el-table .sort-caret {
                width: 0;
                height: 0;
                border: 7px solid transparent;
                position: absolute;
                left: 7px;
            }
        }
        .content-left {
            width: 100%;
            // margin: 0 15px 0 0;
        }
        .comments {
            width: 300px;
        }
        .btn-style{
            // margin-top:10px;
            // padding-left: 5px;
            // margin-left: 5px;
        }
        .checkBox-style{
            margin-left:5px;
            /* margin-right: 0px; */
            .el-checkbox__label{
                padding-left: 5px;
            }
        }
        .report-tree-dialog {
            width: 800px;
            min-width: 600px;
            height: 800px;

        }
        .more-model-desc-search{
            position: relative;
            width: 100%;
            min-height: 40px;
            height: auto;
            margin-top: 10px;
            margin-bottom: 10px;
            display: flex;
            justify-content: flex-start;   /* 左对齐 */
            flex-wrap: wrap;   /* 换行 */
            .more-model-desc-search-item{
                margin-right: 20px;   /* 每个元素右间距设置为20px */
                min-height: 40px;
                height: auto;
                display: flex;
                margin-left: 20px;
                width:22%;
                .render-form-item{
                    display: flex;
                    .search-item-left{
                        width: 120px;
                        text-align: right;
                        padding-right: 6px;
                    }
                    .search-item-right{
                        flex:1;
                        .el-date-editor,.el-input{
                            width: 220px !important;
                        }
                    }
                }
            }
            .more-model-desc-search-item(4n+0) {
                 margin-right: 0;
            }
        }
        .fulltext-search{
          /* width: 150px; */
          position: relative;
          float: right;
        }
    }
    .business-report-tree{
        .report-tree-dialog{
           .el-dialog__body{
               height: ~'calc(100% - 16vh)';
               margin-top: -6vh;
           }
        }
    }
    .popEditModelDetail{
      .el-dialog__body {
        padding: 5px 30px 0px 0px;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
        height: calc(100% - 8vh);
      }
    }
    .search-box{
        .element-editor{
            height: 70vh;
            overflow: auto;
        }
    }
    .show-report{
        .el-dialog__body{
            padding-top: 10px;
        }
    }
    .searchConditonRight{
        .el-drawer__body{
            width: 100%;
            .el-container{
                width: 100%;
                .el-aside{
                    width: 320px !important;
                    .search-opt-btns{
                        width: 320px !important;
                        border-bottom: none;
                        display: block;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/business/BusinessApplication/ModelFormList.vue